/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgUnitReserveRetrievePathOrgUnitId,
	OrgUnitReserveRetrievePathReserveId,
	OrgUnitReserveRetrieveQueryRefresh,
	OrgUnitReserveRetrieveStatus200,
} from "../types/OrgUnitReserveRetrieve.ts";

function getOrgUnitReserveRetrieveUrl(org_unit_id: OrgUnitReserveRetrievePathOrgUnitId, reserve_id: OrgUnitReserveRetrievePathReserveId) {
	const res = { method: "GET", url: `/api/org_unit/${org_unit_id}/reserve/${reserve_id}/` as const };

	return res;
}

/**
 * @summary статус брони
 * {@link /api/org_unit/:org_unit_id/reserve/:reserve_id/}
 */
export async function orgUnitReserveRetrieve(
	org_unit_id: OrgUnitReserveRetrievePathOrgUnitId,
	reserve_id: OrgUnitReserveRetrievePathReserveId,
	params?: { refresh?: OrgUnitReserveRetrieveQueryRefresh },
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgUnitReserveRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgUnitReserveRetrieveUrl(org_unit_id, reserve_id).url.toString(),
		params,
		...requestConfig,
	});

	return res.data;
}
